import * as React from "react";

import { IEventViewProps } from "../EventView";

import { IEvent } from "../../../classes/Event";
import { IText } from "../../../classes/Text";

import { MonthlyListEvent } from "./MonthlyListEvent";
import { MonthlyListNoEvent } from "./MonthlyListNoEvent";

import * as dates from "../../../reducers/changeTimePeriod";

const getMonthlyListEvents = (props: IEventViewProps, isLoading: boolean) => {
    const events: JSX.Element[] = [];

    let count = 0;
    if (!isLoading) {

        // Have to transform the raw list of events for the Event List View, by turning each multi-day event into multiple one-day events.
        const expandedEventsData: IEvent[] = [];

        for (const rawEvent of props.events) {
            expandedEventsData.push(rawEvent);

            // if (dates.getDaysBetweenDates(rawEvent.localStartDate, rawEvent.localEndDate) > 1) {
            //     // Turn single multi-day event into multiple one-day events.

            // } else {
            //     expandedEventsData.push(rawEvent);
            // }
        }

        // Sort events by the time of day for daily list view (not by date+time that events start, which is the default order).
        // const eventsData = props.events.slice(); // Create shallow copy of array.
        // eventsData.sort((a, b) => {
        //     return dates.compareTimeOfDay(a.localStartDate, b.localStartDate, a.name, b.name);
        // });

        // We're hiding the Location and Category columns in this event view to make more room for the Date+Time info.
        for (const event of expandedEventsData) {

            const eventStartsWithinThisMonth = dates.isSameDayOrAfter(event.localStartDate, props.localFromDate) && dates.isSameDayOrBefore(event.localStartDate, props.localToDate);
            const eventEndsWithinThisMonth = dates.isSameDayOrAfter(event.localEndDate, props.localFromDate) && dates.isSameDayOrBefore(event.localEndDate, props.localToDate);
            const eventIsInThisMonth = eventStartsWithinThisMonth || eventEndsWithinThisMonth;

            if (eventIsInThisMonth) {
                events.push(
                    <MonthlyListEvent
                        event={event}
                        eventText={props.text.eventViews.event}
                        allDayText={props.text.eventViews.allDay}
                        onText={props.text.eventViews.on}
                        toText={props.text.eventViews.to}
                        key={count}
                        contextId={props.contextId}
                        selectedDate={props.selectedDate}
                        pageId={props.pageId}
                        parentId={props.parentId}
                        portalId={props.portalId}
                        portletInstanceId={props.portletInstanceId}
                        showCategoryColumn={false}
                        showLocationColumn={false}
                        todaysDate={props.todaysDate}
                        userDateFormat={props.userDateFormat}
                        viewMode={props.viewMode}
                        onStartAjaxCall={props.onStartAjaxCall}
                        onSetEventId={props.onSetEventId}
                        onSetEventScreenMode={props.onSetEventScreenMode}
                        onSetiCalStartDate={props.onSetiCalStartDate}
                        onSetDisplayedEventLocalStartDate={props.onSetDisplayedEventLocalStartDate}
                        onSetDisplayedEventLocalEndDate={props.onSetDisplayedEventLocalEndDate}
                    />);
            }
            count++;
        }
    }

    return events;
};

const getMonthlyListNoEvent = (events: JSX.Element[], isLoading: boolean, noEventsText: string) => {
    let noEvents: JSX.Element;

    if (events.length === 0 && !isLoading) {
        noEvents = <MonthlyListNoEvent noEventsThisMonthText={noEventsText} />;
    }

    return noEvents;
};

export interface IMonthlyListDays extends IEventViewProps {
    isLoading: boolean;
}

export const MonthlyListDays = (props: IMonthlyListDays) => {

    const events = getMonthlyListEvents(props, props.isLoading);
    const noEvents = getMonthlyListNoEvent(events, props.isLoading, props.text.eventViews.noEventsInThisTimePeriod);

    return (
        <div className="CAL-scroll-wrapper">
            <table className="CAL-V-LV-table CAL-V-ML-table" role="presentation">
                <tbody>
                    {events}
                    {noEvents}
                </tbody>
            </table>
        </div>
    );
};
